import { render, staticRenderFns } from "./BorderEditor.vue?vue&type=template&id=635b35a4&scoped=true"
import script from "./BorderEditor.vue?vue&type=script&lang=js"
export * from "./BorderEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635b35a4",
  null
  
)

export default component.exports